import { render, staticRenderFns } from "./MyReservations.vue?vue&type=template&id=260ded11&scoped=true&"
import script from "./MyReservations.vue?vue&type=script&lang=js&"
export * from "./MyReservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260ded11",
  null
  
)

export default component.exports